import { SeverityLevel } from "@sentry/vue";
import { assertNever } from "../../util/assertNever";

export enum LogLevel {
  DEBUG = "debug",
  INFO = "info",
  WARNING = "warning",
  ERROR = "error",
  FATAL = "fatal",
}

export function mapLogLevelToSentrySeverityLevel(logLevel: LogLevel): SeverityLevel {
  switch (logLevel) {
    case LogLevel.DEBUG:
      return "debug";

    case LogLevel.INFO:
      return "info";

    case LogLevel.WARNING:
      return "warning";

    case LogLevel.ERROR:
      return "error";

    case LogLevel.FATAL:
      return "fatal";

    default:
      assertNever(logLevel);
  }
}
